import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { UseRowSelection } from 'hooks/useRowSelection'
import { useTranslation } from 'react-i18next'
import { IOrganization } from 'types/organization'

type Props = {
  organizations: IOrganization[]
  rowSelection: UseRowSelection
}

export const OrganizationTable = ({ organizations, rowSelection }: Props) => {
  const { t } = useTranslation()

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>{t('select')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t('organization-name')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t('orgEmailAddress')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t('taxId')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {organizations.map((organization) => (
            <TableRow key={organization.id}>
              <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  checked={rowSelection.isChecked(organization.id)}
                  onChange={() => rowSelection.toggle(organization.id)}
                />
              </TableCell>
              <TableCell>{organization.name}</TableCell>
              <TableCell>{organization.email}</TableCell>
              <TableCell>{organization.taxId}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
